import { Box, styled } from '@mui/material';

export const ExperienceContentContainer = styled(Box)(() => ({
  width: '100%',
  marginTop: '24px',

  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  columnGap: '24px',

  '@media screen and (max-width: 1280px)': {
    gridTemplateColumns: 'none',
    gridTemplateRows: 'auto 1fr',
    columnGap: 'none',
    rowGap: '24px',
  },
}));
